import React from "react";
import { useTheme } from "./ThemeContext";
import "./ThemeToggle.css";

const ThemeToggle = () => {
  const { theme, toggleTheme, isTouchDevice } = useTheme();
  
  // On touch devices, show a disabled state for candlelight mode
  if (isTouchDevice) {
    return (
      <div className="theme-toggle theme-toggle-touch">
        <div className="toggle-inner">
          <span className="toggle-icon">☀️</span>
          <span className="toggle-text">Daylight</span>
        </div>
      </div>
    );
  }
  
  return (
    <button 
      onClick={toggleTheme}
      className="theme-toggle"
      aria-label={`Switch to ${theme === 'light' ? 'candlelight' : 'daylight'} mode`}
      title={`Switch to ${theme === 'light' ? 'candlelight' : 'daylight'} mode`}
    >
      <div className="toggle-inner">
        <span className="toggle-icon">
          {theme === "light" ? "🕯️" : "☀️"}
        </span>
        <span className="toggle-text">
          {theme === "light" ? "Candlelight" : "Daylight"}
        </span>
      </div>
    </button>
  );
};

export default ThemeToggle;
